import { Subject } from 'rxjs';
import { SCHWAB_ACCOUNT, SCHWAB_CLIENT } from 'IntegrationsApp/ts/constants';
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class SchwabIntegrationService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
        this.otpNeeded = new Subject();
    }
    getSchwabIntegrationStatus() {
        const url = this.urlsService.INTEGRATIONS.SCHWAB_INTEGRATION_STATUS;
        return this.ajaxService.getDataObserveBody(url);
    }
    getOAuthRandomState() {
        const url = this.urlsService.INTEGRATIONS.SCHWAB_INTEGRATION_OAUTH;
        return this.ajaxService.postJsonDataObserveBody(url, {});
    }
    // Currently this also deactivates the legacy Schwab integration
    deactivateSchwabOAuthIntegration() {
        const url = this.urlsService.INTEGRATIONS.SCHWAB_INTEGRATION_OAUTH;
        return this.ajaxService.deleteDataObserveResponse(url);
    }
    getSchwabClientSearchResults(searchTerms, page) {
        const urlParams = { searchType: SCHWAB_CLIENT };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.SCHWAB_SEARCH, urlParams)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getSchwabAccountSearchResults(searchTerms, page) {
        const urlParams = { searchType: SCHWAB_ACCOUNT };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.SCHWAB_SEARCH, urlParams)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getSchwabClientAccounts(clientId, page) {
        const urlParams = { clientId };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.SCHWAB_CLIENT_ACCOUNTS, urlParams)}?page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    importSchwabHoldings(postParams, importType) {
        const urlParams = { importType };
        const url = this.urlsService.getUrl(this.urlsService.INTEGRATIONS.SCHWAB_IMPORT_HOLDINGS, urlParams);
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    getIRebalSearchResults(searchTerms, searchType, page) {
        const urlParams = { searchType };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.SCHWAB_SEARCH, urlParams)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    formatAccounts(accounts) {
        return accounts.map((item) => {
            return {
                ...item,
                title: [item.registrationLineOne, item.registrationLineTwo, String(item.subAccountId)].join(', '),
            };
        });
    }
    postSchwabPushModel(modelPortfolioId, name) {
        const postParams = { modelPortfolioId, name };
        const url = this.urlsService.INTEGRATIONS.SCHWAB_PUSH_MODEL;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
}
SchwabIntegrationService.ɵfac = function SchwabIntegrationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SchwabIntegrationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
SchwabIntegrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SchwabIntegrationService, factory: SchwabIntegrationService.ɵfac, providedIn: 'root' });
